import { useEffect, useRef } from 'react';

const urlFor = (s) => {
  const base = window.location.pathname;
  return !s || s === 'home' ? base : `${base}?s=${encodeURIComponent(s)}`;
};

let replaceNext = false;
// Next section change replaces the current history entry instead of adding one (used by "‹ Back"
// when there is no earlier FBC screen, so Back never loops).
export const replaceNextNavigation = () => { replaceNext = true; };

// Mirrors the current section into browser history: Back/Forward (and Android Back) move between
// FBC screens, refresh keeps the place, and ?s=<section> links can be shared.
export function useSectionHistory(activeSection, setActiveSection) {
  const fromPop = useRef(false);

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const linked = qs.get('s') || qs.get('section');
    if (linked && linked !== activeSection) { fromPop.current = true; setActiveSection(linked); }
    window.history.replaceState({ fbc: linked || activeSection, depth: 0 }, '',
      linked ? urlFor(linked) + (qs.get('req') ? `&req=${encodeURIComponent(qs.get('req'))}` : '') + window.location.hash : window.location.href);
    const onPop = (e) => {
      const target = e.state?.fbc || new URLSearchParams(window.location.search).get('s') || 'home';
      fromPop.current = true;
      setActiveSection(target);
      window.scrollTo(0, 0);
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (fromPop.current) { fromPop.current = false; return; }
    if (window.history.state?.fbc === activeSection) { replaceNext = false; return; }
    if (replaceNext) {
      replaceNext = false;
      window.history.replaceState({ fbc: activeSection, depth: window.history.state?.depth || 0 }, '', urlFor(activeSection));
      return;
    }
    const depth = (window.history.state?.depth || 0) + 1;
    window.history.pushState({ fbc: activeSection, depth }, '', urlFor(activeSection));
  }, [activeSection]);
}

export const canGoBackInApp = () => (window.history.state?.depth || 0) > 0;
